export default __webpack_public_path__ + "static/media/icons8-share-100.c8591318.svg";